export const iconFontAwesomeHumanitarianWind = (
	<i className="fa-solid fa-wind"></i>
);
